// removed by extract-text-webpack-plugin
module.exports = {"h2":"NmPxmL4bAJ16m_9Ust7uE","bigButton":"_3tQWJYgH-BIsGAhayfHari","linkText":"vHZKZeNMeL08j7KpkKwcC"};


//////////////////
// WEBPACK FOOTER
// ./src/components/notification/notificationComponent.scss
// module id = 682
// module chunks = 22